import { createSelector } from 'reselect';

const selectDataDomain = () => (state) => {
  return state.get('form');
};

const makeSelectData = () => {
  const something = createSelector(selectDataDomain(), (substate) => substate.toJS());
  return something;
  // const returnedState = selector();
  // console.log('selector returns THIS: ', returnedState)
  // return selector();
};

export default makeSelectData;



// WEBPACK FOOTER //
// ./src/application-form/selectors.js